import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
export const treeToArray = (tree) => {
    if (tree) {
        const deviceList = [];
        const deep = (tree) => {
            tree.forEach(item => {
                const { children, ...data } = item;
                deviceList.push(data);
                if (children && children.length > 0) {
                    deep(children);
                }
            });
        };
        deep(tree);
        return deviceList;
    }
};
let DeviceIdTree = class DeviceIdTree extends VuexModule {
    deviceIdList = [];
    deviceIdTree = [];
    rtspUrl = '';
    treeIsDdata = false;
    deviceIdMap = new Map();
    get treeToDeviceIdList() {
        if (this.deviceIdTree) {
            return treeToArray(this.deviceIdTree);
        }
    }
    setMapValue() {
        const treedata = treeToArray(this.deviceIdTree);
        if (treedata && treedata?.length > 0) {
            treedata.forEach(item => {
                if (item.nodeType === 'DEVICE') {
                    this.deviceIdMap.set(item.id, item.name);
                }
            });
        }
    }
    getDeviceIdList(treeData) {
        this.deviceIdTree = treeData;
    }
    updataTreeIsDdata(data) {
        this.treeIsDdata = data;
    }
};
__decorate([
    Mutation
], DeviceIdTree.prototype, "setMapValue", null);
__decorate([
    Mutation
], DeviceIdTree.prototype, "getDeviceIdList", null);
__decorate([
    Mutation
], DeviceIdTree.prototype, "updataTreeIsDdata", null);
DeviceIdTree = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/DeviceIdTree' })
], DeviceIdTree);
export const HandleDeviceIdTree = getModule(DeviceIdTree);
